import { useMemo, useState, useEffect } from 'react';

var getSubscribePath = ({ getState, subscribe }) => {
  const listeners = new Map();
  const subscribePath = (path, subscription) => {
    let listener;
    let curListeners = listeners;
    let state = getState();
    path.forEach((name) => {
      listener = curListeners.get(name);
      if (!listener) {
        listener = { subscribes: [], children: new Map() };
        curListeners.set(name, listener);
      }
      curListeners = listener.children;
      state = state && state[name];
    });
    if (listener) {
      listener.subscribes.push(subscription);
    }
    return [
      state,
      () => {
        listener.subscribes.splice(listener.subscribes.indexOf(subscription), 1);
      },
    ];
  };

  const fire = (prevState, state, subListeners) => {
    // eslint-disable-next-line no-restricted-syntax
    for (const [name, listener] of subListeners.entries()) {
      const prevSubState = prevState && prevState[name];
      const subState = state && state[name];
      if (prevSubState !== subState) {
        listener.subscribes.forEach((subscription) => subscription(subState));
        fire(prevSubState, subState, listener.children);
      }
    }
  };

  let prevState = null;
  const changeHandler = () => {
    const state = getState();
    fire(prevState, state, listeners);
    prevState = state;
  };

  subscribe(changeHandler);

  return subscribePath;
};

var getUseStorePath = (store) => {
  const subscribePath = getSubscribePath(store);
  return (path) => {
    const [ref, initValue, clear] = useMemo(
      () => [{}, ...subscribePath(path, (v) => ref.set(v))],
      path,
    );
    const [v, set] = useState(initValue);
    ref.set = set;
    useEffect(() => clear, [clear]);
    return v;
  };
};

export { getSubscribePath, getUseStorePath };
